import { render, staticRenderFns } from "./EmailPlantillas.vue?vue&type=template&id=6f107fd4&scoped=true&"
import script from "./EmailPlantillas.vue?vue&type=script&lang=js&"
export * from "./EmailPlantillas.vue?vue&type=script&lang=js&"
import style0 from "./EmailPlantillas.vue?vue&type=style&index=0&id=6f107fd4&prod&lang=scss&"
import style1 from "./EmailPlantillas.vue?vue&type=style&index=1&id=6f107fd4&prod&lang=scss&scoped=true&"
import style2 from "./EmailPlantillas.vue?vue&type=style&index=2&id=6f107fd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f107fd4",
  null
  
)

export default component.exports